import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getMaintenanceCompanyList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditMaintenanceCompanyModal from './Add_Edit/AddEditMaintenance';
import DeleteMaintenanceCompanyModal from './Delete/DeleteMaintenance';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const MaintenanceCompanyList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorMaintenanceCompany = createSelector(
		state => state.MaintenanceCompany,
		maintenanceCompany => ({
			maintenanceCompanyList: maintenanceCompany.itemMaintenanceCompanyList,
			isLoadingList: maintenanceCompany.isLoadingList,
			isMaintenanceCompanySuccess: maintenanceCompany.isMaintenanceCompanySuccess,
			error: maintenanceCompany.error,
			isAdding: maintenanceCompany.isAdding,
			isAdded: maintenanceCompany.isAdded,
			isAddError: maintenanceCompany.isAddError,
			isUpdating: maintenanceCompany.isUpdating,
			isUpdated: maintenanceCompany.isUpdated,
			isUpdateError: maintenanceCompany.isUpdateError,
			isDeleting: maintenanceCompany.isDeleting,
			isDeleted: maintenanceCompany.isDeleted,
			isDeleteError: maintenanceCompany.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { maintenanceCompanyList, isLoadingList } = useSelector(selectorMaintenanceCompany);

	useEffect(() => {
		dispatch(getMaintenanceCompanyList());
	}, []);

	const [dataMaintenanceCompany, setDataMaintenanceCompany] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete MaintenanceCompany
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = maintenanceCompany => {
		setDataMaintenanceCompany(maintenanceCompany);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = maintenanceCompany => {
		setDataMaintenanceCompany(maintenanceCompany);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'maintenanceCompany',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const maintenanceCompanyData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(maintenanceCompanyData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const maintenanceCompanyData =
														cellProps.row.original;
													handleClickDelete(maintenanceCompanyData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{ header: 'Correo', accessorKey: 'mail', size: 'auto' },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataMaintenanceCompany({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Empresa de Mantenimiento
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={maintenanceCompanyList || []}
								isLoadingData={isLoadingList}
								nameFile={'maintenanceCompany'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataMaintenanceCompany({});
											handleToggleModal();
										},
										title: 'Crear Empresa de Mantenimiento'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditMaintenanceCompanyModal
				dataMaintenanceCompany={dataMaintenanceCompany}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteMaintenanceCompanyModal
				dataMaintenanceCompany={dataMaintenanceCompany}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default MaintenanceCompanyList;
